import {map, reduce, sorted} from '../lang/array';
import {isArray} from '../lang/is';
import {keys, owns} from '../lang/object';
import {parse, unparse} from './urls';

const
    encode = (values, canonical) => (
        map(
            (canonical ? sorted : value => value)(
                reduce(
                    keys(values || {}),
                    (pairs, name) => {
                        const
                            key = encodeURIComponent(name),
                            value = values[name];

                        return (
                            reduce(
                                isArray(value) ? value : [value],
                                (pairs, value) => {
                                    pairs.push([key, encodeURIComponent(value)]);
                                    return pairs;
                                },
                                pairs));
                    },
                    []),
                ([lkey, lvalue], [rkey, rvalue]) => (
                    lkey < rkey ?
                        -1 :
                        lkey > rkey ?
                            1 :
                            lvalue < rvalue ?
                                -1 :
                                lvalue > rvalue ?
                                    1 :
                                    0)),
            ([key, value]) => `${key}=${value}`)
        .join('&')),

    decode = string => (
        reduce(
            (string || '').split('&'),
            (values, term) => {
                const [key, encoded] = term.split('=');

                if (key) {
                    const
                        name = decodeURIComponent(key),
                        value = decodeURIComponent(encoded || '') || true;

                    if (owns(values, name)) {
                        if (!isArray(values[name])) {
                            values[name] = [values[name]];
                        }
                        values[name].push(value);
                    } else {
                        values[name] = value;
                    }
                }
                return values;
            },
            {})),

    updated = (uri, values, canonical) => {
        const
            parts = parse(uri || ''),
            search = {
                ...decode(parts.search.slice(1)),
                ...values || {}
            };

        return (
            unparse({
                ...parts,
                ...keys(search).length ?
                    {search: `?${encode(search, canonical)}`} :
                    {}
            }));
    };

export {
    encode,
    decode,
    updated
};
